import { render, staticRenderFns } from "./submit-success.vue?vue&type=template&id=97e389b2&scoped=true&"
import script from "./submit-success.vue?vue&type=script&lang=js&"
export * from "./submit-success.vue?vue&type=script&lang=js&"
import style0 from "./submit-success.vue?vue&type=style&index=0&id=97e389b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e389b2",
  null
  
)

export default component.exports